import moment from "moment";

/** How to display dates in the UI. */
export class DateFormatter {

    static displayDateFormat = "DD.MM.YYYY";
    static displayDateTimeFormat = "DD.MM.YYYY hh:mm:ss a";
    static displayDateTime24HRSFormat = "DD.MMM.YYYY HH:mm:ss";

    static applyDateFormat(value: Date) {
        return moment(value).format(this.displayDateFormat);
    }

    static applyDateTimeFormat(value: Date) {
        return moment(value).format(this.displayDateTimeFormat);
    }
    static applyDateTime24HRSFormat(value: Date) {
        return moment(value).format(this.displayDateTime24HRSFormat);
    }
}



// WEBPACK FOOTER //
// ./src/utils/DateFormatter.tsx